module.exports = __webpack_public_path__ + "img/hzjg.8f6022e7.png";